import { _decorator, RenderTexture } from 'cc';
import UVLRTBProvider from './UVLRTBProvider';

const { ccclass, executeInEditMode } = _decorator;

enum ShaderPropertyName {
    SCRATCH_TEXTURE = 'scratchTexture',
    USE_SCRATCH_TEXTURE = 'useScratchTexture',
}

@ccclass('ScratchTarget')
@executeInEditMode
export default class ScratchTarget extends UVLRTBProvider {
    public static readonly SHADER_PROPERTY_NAME = ShaderPropertyName;

    private _scratchTexture: RenderTexture = null;

    public get scratchTexture() {
        return this._scratchTexture;
    }
    public set scratchTexture(value: RenderTexture) {
        if (this._scratchTexture === value) {
            return;
        }
        this._scratchTexture = value;
        this.updateScratchTextureProperty();
        this.updateUseScratchTextureProperty();
    }

    protected onDisable() {
        super.onDisable();
        this.updateUseScratchTextureProperty();
    }

    protected syncProperty() {
        super.syncProperty();
        this.updateScratchTextureProperty();
        this.updateUseScratchTextureProperty();
    }

    protected updateScratchTextureProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }

        if (this.scratchTexture) {
            pass.bindTexture(pass.getBinding(ShaderPropertyName.SCRATCH_TEXTURE), this.scratchTexture.getGFXTexture());
            pass.bindSampler(pass.getBinding(ShaderPropertyName.SCRATCH_TEXTURE), this.scratchTexture.getGFXSampler());
        }
    }

    protected updateUseScratchTextureProperty() {
        const pass = this.targetPass;
        if (!pass) {
            return;
        }
        pass.setUniform(pass.getHandle(ShaderPropertyName.USE_SCRATCH_TEXTURE), this.scratchTexture && this.enabled ? 1 : 0);
    }
}
